export const isVideoFile = (file) =>
  (file.type || "").startsWith("video/") || /\.(mp4|webm|mov)$/i.test(file.name || "");

export async function chunkedUpload(API, file, onProgress) {
  const initRes = await fetch(`${API}/api/admin/upload/init`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ filename: file.name, content_type: file.type || "application/octet-stream", size: file.size }),
  });
  const init = await initRes.json();
  if (!initRes.ok) throw new Error(typeof init.detail === "string" ? init.detail : "Upload failed");
  const chunkSize = init.chunk_size || 4 * 1024 * 1024;
  for (let offset = 0; offset < file.size; offset += chunkSize) {
    const blob = file.slice(offset, Math.min(offset + chunkSize, file.size));
    const res = await fetch(`${API}/api/admin/upload/chunk/${init.id}`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/octet-stream" },
      body: blob,
    });
    if (!res.ok) {
      const err = await res.json().catch(() => null);
      throw new Error(typeof (err && err.detail) === "string" ? err.detail : "Upload failed");
    }
    onProgress(Math.min(99, Math.round(((offset + blob.size) / file.size) * 100)));
  }
  const doneRes = await fetch(`${API}/api/admin/upload/complete/${init.id}`, {
    method: "POST",
    credentials: "include",
  });
  const done = await doneRes.json();
  if (!doneRes.ok) throw new Error(typeof done.detail === "string" ? done.detail : "Upload failed");
  return done;
}
